import { render, staticRenderFns } from "./GSTRateForm.vue?vue&type=template&id=29bb021e&scoped=true"
import script from "./GSTRateForm.vue?vue&type=script&lang=js"
export * from "./GSTRateForm.vue?vue&type=script&lang=js"
import style0 from "./GSTRateForm.vue?vue&type=style&index=0&id=29bb021e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bb021e",
  null
  
)

export default component.exports